module.exports = __webpack_public_path__ + "img/48dea6714908610b48e3e4672cf17646.png";